import { render, staticRenderFns } from "./Discussions.vue?vue&type=template&id=54fdb10f&scoped=true&"
import script from "./Discussions.vue?vue&type=script&lang=js&"
export * from "./Discussions.vue?vue&type=script&lang=js&"
import style0 from "./Discussions.vue?vue&type=style&index=0&id=54fdb10f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fdb10f",
  null
  
)

export default component.exports